import { render, staticRenderFns } from "./MacroEconomy.vue?vue&type=template&id=5a90c675&scoped=true"
import script from "./MacroEconomy.vue?vue&type=script&lang=js"
export * from "./MacroEconomy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a90c675",
  null
  
)

export default component.exports